import { MAX_PINNED_THREADS } from '@/features/chat/pinnedThreadsConstants'
import { applyThreadPinState } from './applyThreadPinState'

export function handleThreadMenuPin(thread, m) {
  const pinnedIds = m.pinnedThreadIds ?? []
  if (!pinnedIds.includes(thread.id) && pinnedIds.length >= MAX_PINNED_THREADS) {
    m.setPinLimitDialogOpen(true)
    return
  }
  applyThreadPinState(thread, m, true)
}

export function handleThreadMenuUnpin(thread, m) {
  applyThreadPinState(thread, m, false)
}
